import { createSelector } from 'reselect'

import { selectActualHasLimitedPocView } from 'containers/App/selectors'
import { URL_STATE } from 'containers/ResolutionCenter/List/constants'

import { EXCLUDING_THEMIS_SPAM_SAFE_OPTION } from '../constants'
import { selectUrlState } from '../List/selectors'
import { selectGeneralFilterOptions } from '../selectors'

import { SORTING_OPTIONS } from './constants'

// Frozen so repeated calls with the same limited-POC-view state don't return
// a fresh single-element array each time (react-redux 8 selector stability).
const EXCLUDING_THEMIS_SPAM_SAFE_OPTIONS = Object.freeze([EXCLUDING_THEMIS_SPAM_SAFE_OPTION])

const selectSearch = (state) => state.resolutioncenter.topBar.search
const selectSortingBy = (state) => state.resolutioncenter.topBar.sortingBy
const selectSortingDirection = (state) => state.resolutioncenter.topBar.sortingDirection || 'desc'
const selectGeneralFilter = (state) => state.resolutioncenter.topBar.generalFilter

const selectSortingOptions = createSelector(selectUrlState, (urlState) => {
  if (urlState === URL_STATE.UNCLASSIFIED) return SORTING_OPTIONS
  return SORTING_OPTIONS.filter((e) => e.value !== 'priority')
})

const selectChallengedTypeFilter = (state) => state.resolutioncenter.topBar.challengedTypeFilter

const selectScanBackGeneralFilter = (state) => {
  const allFilters = selectGeneralFilterOptions(state)
  const hasLimitedPocView = selectActualHasLimitedPocView(state)
  if (hasLimitedPocView) return EXCLUDING_THEMIS_SPAM_SAFE_OPTIONS
  else return allFilters
}

export {
  selectSearch,
  selectSortingBy,
  selectSortingDirection,
  selectGeneralFilter,
  selectChallengedTypeFilter,
  selectSortingOptions,
  selectScanBackGeneralFilter,
}
